var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 155",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    className: "style-scope yt-icon",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    viewBox: "0 0 155 155",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9 76.2C3.9 37.9 32.7 13 68.3 13c39.1 0 65.4 27.6 64.4 63.2 0 3.1-.3 6.2-.7 9.2-.7 4.8-6.2 8-7.8 12.4-1.8 5 .2 11-2.7 15.4a59.7 59.7 0 0 1-18.6 17.7c-9.6 5.9-21.6 4-35 4.3-12.7.4-24 2.9-33.8-2.7-18.5-10.6-30.2-30.9-30.2-56.3",
    fill: "#EEE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7 92.5c14.1-6.8 5.6-21 1.4-26.3 4.3 3.2 7.6 1.6 9.2.3 1.7-1.3 2.6-5-.9-8-3.4-3-13.9-13.5-21.6-20.8-.3-.2-18.6-1.7-28.2 8.3-8.6 8.9-14.4 33.2-14.4 33.2 16.1 23.5 11.9 35 5.6 44.5 10.7 7.7 49-6.6 48-7.6-9.1-8.1-10.2-18.3.9-23.6",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 115.7)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 .4h74V25H1z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.3 25c8.7-.3 16.8-1.9 24-4.6 1.7-.6 1-1.4 2.7-2.2 1.4-.6 5.2-1.3 6.5-2.1l1.4-.9c-2.2-1-5.7-2.7-9.5-4.8-1.2-.6-4.1-.9-5.4-1.6-1.3-.7-.9-2-2.2-2.7a100.6 100.6 0 0 1-8-5.7H6.3c-1 5.3-3 9.7-5.3 13.1 1.2 1 2.5 1.8 3.9 2.6s5.3 1.4 6.8 2.1c1.4.7.4 1.6 1.8 2.2 8 3.3 17.1 4.9 26.8 4.6",
    fill: "#00D4B5",
    mask: "url(#account_settings__b)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.9 131.8a59 59 0 0 0 8.6 4.3h50.7c3.3-1.2 6.4-2.7 9.3-4.3H32.9zM37.6 126h55.8c-2.5-1.2-5-2.7-7.6-4.2H37.6v4.3z",
    fill: "#FFF",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4 55c14.1 1.7 14.1 14.3 14.1 14.3L55 74s-2.3-3.3-7.8-2.1c2.2 1.3 3.7 3.2 4.8 5.3 2.6 5.1 2.1 13-6 16.4-3 1.2-7 4-7.3 8.3-.4 6.5 4.6 10 11.6 8.7 2 9-6.2 24.8-26.9 22.5a22.9 22.9 0 0 1-18-32.7c5.4-11.8 22.4-14.7 18.9-21L46.4 55z",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1 32a31 31 0 0 0-27 9.3C22.7 47.9 17.2 57 19 67.7c.8 3.7 40.7-35 37-35.7",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 35c0-5.2 4-8.5 8.7-8.5 5.3 0 8.9 3.7 8.7 8.5a8.6 8.6 0 0 1-8.7 8.7c-5 .1-8.7-3.5-8.7-8.7",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9 72.5c-2.8-1.3-6-1-6.8 2.3-.6 2.2.3 5.8 4.8 7.4a27.9 27.9 0 0 0 14.4 1.3c.6-3.1-.2-6.4-1.4-9.4-2.7.4-6.8.4-11-1.6",
    fill: "#FFF",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 46H75.7c-3.6 0-5 2-5 5 0 2.9.7 5.7 4.6 5.7h30.3l-1-10.7z",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8 42.6h-29c-5.8 0-8.3 3.3-8.3 8 0 4.8 2.3 9.4 7.8 9.4h28.4l1.1-17.4z",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3 57.8a.8.8 0 0 1-.6-.4 13 13 0 0 1-1.2-6.5c0-.4.4-.7.8-.7s.7.4.7.8c-.2 1.9.2 4.3 1 5.7a.8.8 0 0 1-.7 1.1",
    fill: "#9A4DFF",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 51.2c0-6.9 4.8-11.4 10.7-11.4 6.4 0 10.8 5 10.6 11.4-.2 6.6-4.2 11.5-10.6 11.7-6.1.2-10.6-4.6-10.6-11.7",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1 51.3c0-3.7 2.5-6 5.6-6 3.4 0 5.7 2.6 5.6 6-.1 3.4-2.3 6-5.6 6.1-3.2.1-5.6-2.4-5.6-6.1",
    fill: "#FFF",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.4 66c.7-5.9 0-10.4-3.3-10.8-3.4-.4-4.5 4-4.5 4s.2-4.5-3-5c-3.2-.4-4.6 4.4-4.6 4.4s.9-4.7-3.6-4.3c-4.5.3-9.2 11.5-7.2 28.3a38.3 38.3 0 0 0 23.3 30.6c5.4-8 9-17.5 10.4-27.8-5.5-3.5-8.3-12.3-7.5-19.5",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 71.7a.8.8 0 0 1-.7-.8c0-2.6.7-7.8 1.4-10.7 0-.4.5-.7.9-.6.4 0 .6.5.5.9-.7 3.2-1.3 8.1-1.3 10.4 0 .4-.3.8-.7.8M114.8 71.7a.8.8 0 0 1-.7-.8c0-2.6.7-7.8 1.3-10.7.1-.4.5-.7 1-.6.3 0 .6.5.5.9-.7 3.2-1.3 8.1-1.3 10.4 0 .4-.4.8-.8.8",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8 37.7l-.7-.6a20.2 20.2 0 0 0-10-5L19.2 67.6c.7 3.7 2.3 7.5 5 11.5l42.6-41.5z",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6 55.4C59.1 53 71.6 45 66.8 37.7L48.6 55.4z",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLook);
export default __webpack_public_path__ + "static/media/look.75d0fab05f94357b613375275cb1a354.svg";
export { ForwardRef as ReactComponent };